import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
} from "@chakra-ui/react";

export default function FormInput({
  type,
  name,
  placeholder,
  value,
  onChange,
  required,
  helper,
  children,
}) {
  return (
    <FormControl isRequired={required}>
      <FormLabel htmlFor={name}>{children}</FormLabel>
      <Input
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {helper && <FormHelperText>{helper}</FormHelperText>}
    </FormControl>
  );
}
